import jupApi from '../jup-api'
import type {
  JupErrorResponse,
  JupTokenSearchResponse,
  JupOrderResponse,
  JupBalancesResponse,
} from './types'

export const JupiterService = {
  getOrder(apiKey: string, input: string, output: string, amount: string, taker: string, dexes?: string, slippageBps?: number) {
    let url = `/ultra/v1/order?inputMint=${input}&outputMint=${output}&amount=${amount}&taker=${taker}`
    if (dexes) {
      url += `&dexes=${encodeURIComponent(dexes)}`
    }
    if (slippageBps !== undefined && slippageBps > 0) {
      url += `&slippageBps=${slippageBps}`
    }
    return jupApi.get<JupOrderResponse | JupErrorResponse>(
      url,
      {
        headers: {
          'x-api-key': apiKey,
        },
      },
    )
  },
  search(apiKey: string, query: string) {
    return jupApi.get<JupTokenSearchResponse | JupErrorResponse>(
      `/tokens/v2/search?query=${query}`,
      {
        headers: {
          'x-api-key': apiKey,
        },
      },
    )
  },
  getBalances(apiKey: string, address: string) {
    return jupApi.get<JupBalancesResponse | JupErrorResponse>(`/ultra/v1/balances/${address}`, {
      headers: {
        'x-api-key': apiKey,
      },
    })
  },
  execute(apiKey: string, tx: string, req: string) {
    return jupApi.post(
      `/ultra/v1/execute`,
      {
        signedTransaction: tx,
        requestId: req,
      },
      {
        headers: {
          'x-api-key': apiKey,
        },
      },
    )
  },
}
